import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import DateTimeCustom from 'Components/react-datetime-custom';
import styles from './JobQuerySearchPanel.module.css';

const initialState = {
    account: "",
    from_date: moment(new Date()).subtract(7, 'days'),
    to_date: moment(new Date()),
    job_number: "",
    reference1: "",
    reference2: "",
    service_code: "",
    pickup_suburb: "",
    delivery_suburb: "",
    booked_by: ""
};

export default class JobQuerySearchPanel extends React.Component {
    constructor(props) {
        super(props);

        var state = {};

        Object.assign(state, initialState);

        if (props.query) {

            var query = props.query;

            Object.assign(state, {
                account: query.account,
                from_date: moment(query.from_date,"YYYY-MM-DD"),
                to_date: moment(query.to_date,"YYYY-MM-DD"),
                job_number: query.job_number,
                reference1: query.reference1,
                reference2: query.reference2,
                service_code: query.service_code,
                pickup_suburb: query.pickup_suburb,
                delivery_suburb: query.delivery_suburb,
                booked_by: query.booked_by
            });
        } else if (props.defaultAccount) {
            Object.assign(state, {
                account: props.defaultAccount
            });
        }

        this.state = state;

        this.resetForm = this.resetForm.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.handleDatetimeChange = this.handleDatetimeChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    resetForm(event) {
        event.preventDefault();

        var state = {};

        Object.assign(state, initialState);

        if (this.props.defaultAccount) {
            Object.assign(state, {
                account: this.props.defaultAccount
            })
        }

        this.setState(state);
    }

    handleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleAccountChange(event){

        this.handleChange(event);

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        if (typeof this.props.onAccountChanged === 'function') {
            this.props.onAccountChanged(value);
        }
    }

    handleDatetimeChange(moment,name) {
        this.setState({[name]: moment});
    }

    handleSubmit(event) {
        event.preventDefault();

        const formData = new FormData(document.getElementById('form-query'));

        if (this.props.onFormSubmit) {
            this.props.onFormSubmit(formData);
        }
    }

    render() {

        var accountOptions = null;

        if (this.props.accountOptions !== undefined && this.props.accountOptions !== null) {
            var sortedAccounts = _.sortBy(this.props.accountOptions, ['label']);
            accountOptions = sortedAccounts.map(
                (a) => <option key={a.value} value={a.value}>{a.label}</option>
                );
        }

        return (
            <form id="form-query" styleName="styles.form" onSubmit={this.handleSubmit}>
                <div className="container-fluid padding-lr55 bg-form">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <div className="row h3">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">Job Query</div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-10">
                            <div className="row">
                                <div className="col-xs-12 col-sm-4 col-md-3 col-lg-2">
                                    <div className="form-group">
                                        <label htmlFor="job_number">Deadline Account</label>
                                        <select className="form-control" name="account" value={this.state.account} onChange={this.handleAccountChange}>
                                            {accountOptions}
                                        </select>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-4 col-md-3 col-lg-2">
                                    <div className="form-group">
                                        <label htmlFor="from_date">From (date)</label>
                                        {<DateTimeCustom id="from_date" name="from_date"
                                            inputProps={{name:"from_date"}}
                                            dateFormat="D/M/YYYY" timeFormat={false} closeOnSelect={true} spanClass="glyphicon-calendar"
                                            value={this.state.from_date}
                                            onChange={moment => this.handleDatetimeChange(moment, 'from_date')}/>}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-4 col-md-3 col-lg-2">
                                    <div className="form-group">
                                        <label htmlFor="to_date">To (date)</label>
                                        {<DateTimeCustom id="to_date" name="to_date"
                                            inputProps={{name:"to_date"}}
                                            dateFormat="D/M/YYYY" timeFormat={false} closeOnSelect={true} spanClass="glyphicon-calendar"
                                            value={this.state.to_date}
                                            onChange={moment => this.handleDatetimeChange(moment, 'to_date')}/>}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-4 col-md-3 col-lg-2">
                                    <div className="form-group">
                                        <label htmlFor="job_number">Job Number</label>
                                        <input className="form-control" type="text" name="job_number" value={this.state.job_number} onChange={this.handleChange}/>
                                    </div>
                                </div>
                                <div className="clearfix visible-md-block"></div>
                                <div className="col-xs-12 col-sm-4 col-md-3 col-lg-2">
                                    <div className="form-group">
                                        <label htmlFor="service">Service Code</label>
                                        <input className="form-control" type="text" id="service" name="service_code" value={this.state.service_code} onChange={this.handleChange}/>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-4 col-md-3 col-lg-2">
                                    <div className="form-group">
                                        <label htmlFor="booked_by">Booked By</label>
                                        <input className="form-control" type="text" id="booked_by" name="booked_by" value={this.state.booked_by} onChange={this.handleChange}/>
                                    </div>
                                </div>
                                <div className="clearfix visible-lg-block"></div>
                                <div className="col-xs-12 col-sm-4 col-md-3 col-lg-2">
                                    <div className="form-group">
                                        <label htmlFor="ref1">Ref 1</label>
                                        <input className="form-control" type="text" id="ref1" name="reference1" value={this.state.reference1} onChange={this.handleChange}/>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-4 col-md-3 col-lg-2">
                                    <div className="form-group">
                                        <label htmlFor="ref2">Ref 2</label>
                                        <input className="form-control" type="text" id="ref2" name="reference2" value={this.state.reference2} onChange={this.handleChange}/>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-4 col-md-3 col-lg-2">
                                    <div className="form-group">
                                        <label htmlFor="pickup_suburb">Pickup Suburb</label>
                                        <input className="form-control" type="text" id="pickup_suburb" name="pickup_suburb" value={this.state.pickup_suburb} onChange={this.handleChange}/>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-4 col-md-3 col-lg-2">
                                    <div className="form-group">
                                        <label htmlFor="delivery_suburb">Delivery Suburb</label>
                                        <input className="form-control" type="text" id="delivery_suburb" name="delivery_suburb" value={this.state.delivery_suburb} onChange={this.handleChange}/>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2"> 
                            <div styleName="styles.padding-label" />
                            <button type="submit" className="btn btn-dl-green" onClick={this.doQuery}>QUERY JOBS</button>
                            <button type="button" className="btn btn-dl-green" onClick={this.resetForm}>CLEAR</button>
                        </div>
                    </div>
                    <div className="padding-tb10" />
                </div>
            </form>
            );
    }
}